import React, { useState } from "react";
import "../../styles/desktop/agendamento.css";
import ListaAgendados from "./Lista-de-Agendamentos/listaAgendados";
import { Agendamento } from "../../API/basic/agendamento/Agendar";
import { iluminacaoConfig } from "../../configs/iluminação";
import { exaustoresConfig } from "../../configs/exaustores";

function TelaTemporizacao() {
  // ----------------------- Função de validação -----------------------
  const scheduleIsValid = (group, start, end) => {
    if (!group || !start || !end) return false;     // campos obrigatórios
    return true;                                    // Se todos os campos estiverem preenchidos, é válido
  };

  // ----------------------- Estados Luzes -----------------------------
  const [grupoLuz, setGrupoLuz] = useState(iluminacaoConfig[0].descricao);
  const [inicioLuz, setInicioLuz] = useState("");
  const [fimLuz, setFimLuz] = useState("");
  const [onValueLuz, setOnValueLuz] = useState(JSON.stringify({ 
    modulo: iluminacaoConfig[0].modulo, 
    idx: iluminacaoConfig[0].idx, 
    status: "ON" 
  }));
  const [offValueLuz, setOffValueLuz] = useState(JSON.stringify({ 
    modulo: iluminacaoConfig[0].modulo, 
    idx: iluminacaoConfig[0].idx, 
    status: "OFF" 
  }));

  // ----------------------- Estados Exaustor --------------------------
  const [grupoExaustor, setGrupoExaustor] = useState(exaustoresConfig[0].descricao);
  const [inicioExaustor, setInicioExaustor] = useState("");
  const [fimExaustor, setFimExaustor] = useState("");
  const [onValueExaustor, setOnValueExaustor] = useState(JSON.stringify({ 
    modulo: exaustoresConfig[0].modulo, 
    idx: exaustoresConfig[0].idx, 
    status: "ON" 
  }));
  const [offValueExaustor, setOffValueExaustor] = useState(JSON.stringify({ 
    modulo: exaustoresConfig[0].modulo, 
    idx: exaustoresConfig[0].idx, 
    status: "OFF" 
  }));

  // ----------------------- Controle de recarga -----------------------
  const [refreshFlag, setRefreshFlag] = useState(false);

  // ----------------------- Handler dos <select> ---------------------
  const handleLuzSelectChange = (e) => {
    const selectedDescricao = e.target.value;
    const selectedCircuit = iluminacaoConfig.find(c => c.descricao === selectedDescricao);
    
    if (selectedCircuit) {
      setGrupoLuz(selectedDescricao);
      setOnValueLuz(JSON.stringify({ 
        modulo: selectedCircuit.modulo, 
        idx: selectedCircuit.idx, 
        status: "ON" 
      }));
      setOffValueLuz(JSON.stringify({ 
        modulo: selectedCircuit.modulo, 
        idx: selectedCircuit.idx, 
        status: "OFF" 
      }));
    }
  };

  const handleExaustorSelectChange = (e) => {
    const selectedDescricao = e.target.value;
    const selectedExaustor = exaustoresConfig.find(ex => ex.descricao === selectedDescricao);
    
    if (selectedExaustor) {
      setGrupoExaustor(selectedDescricao);
      setOnValueExaustor(JSON.stringify({ 
        modulo: selectedExaustor.modulo, 
        idx: selectedExaustor.idx, 
        status: "ON" 
      }));
      setOffValueExaustor(JSON.stringify({ 
        modulo: selectedExaustor.modulo, 
        idx: selectedExaustor.idx, 
        status: "OFF" 
      }));
    }
  };

  // ----------------------- Função principal --------------------------
  const temporizar = async () => {
    const luzOk = scheduleIsValid(grupoLuz, inicioLuz, fimLuz);
    const exaustorOk = scheduleIsValid(grupoExaustor, inicioExaustor, fimExaustor);

    if (!luzOk && !exaustorOk) {
      alert("Preencha todos os campos.");
      return;
    }

    try {
      if (luzOk) {
        await Agendamento(grupoLuz, inicioLuz, fimLuz, onValueLuz, offValueLuz, "Iluminação");
        setInicioLuz("");
        setFimLuz("");
      }

      if (exaustorOk) {
        await Agendamento(grupoExaustor, inicioExaustor, fimExaustor, onValueExaustor, offValueExaustor, "Exaustor");
        setInicioExaustor("");
        setFimExaustor("");
      }

      setRefreshFlag((prev) => !prev);          // força recarga da lista
      alert("Agendamento(s) salvo(s) com sucesso!");
    } catch (error) {
      console.error(error);
      alert("Erro ao salvar agendamento.");
    }
  };

  // ----------------------- JSX ---------------------------------------
  return (
    <div id="TelaTemporizacao">
      <div id="temporizacao">
        <h1>Agendamentos diários</h1>
        <div id="temporizacaoContent">
          {/* -------------------- Luzes -------------------- */}
          <div id="temporizacaoContent1">
            <h2>Luzes</h2>
            <div id="temporizacaoContent1-1">
              Grupo
              <select
                id="selectGrupoLuz"
                onChange={handleLuzSelectChange}
                value={grupoLuz}
              >
                {iluminacaoConfig.map((circuito) => (
                  <option 
                    key={circuito.id} 
                    value={circuito.descricao}
                  >
                    {circuito.descricao}
                  </option>
                ))}
              </select>
              <label htmlFor="temporizacao1">Inicio</label>
              <input
                type="time"
                id="inicioLuz"
                name="temporizacao1"
                value={inicioLuz}
                onChange={(e) => setInicioLuz(e.target.value)}
              />
              <label htmlFor="temporizacao2">Fim</label>
              <input
                type="time"
                id="fimLuz"
                name="temporizacao2"
                value={fimLuz}
                onChange={(e) => setFimLuz(e.target.value)}
              />
            </div>
          </div>

          {/* -------------------- Exaustor -------------------- */}
          <div id="temporizacaoContent2">
            <h2>Exaustor</h2>
            <div id="temporizacaoContent2-1">
              Grupo
              <select
                id="selectGrupoExaustores"
                onChange={handleExaustorSelectChange}
                value={grupoExaustor}
              >
                {exaustoresConfig.map((exaustor) => (
                  <option 
                    key={exaustor.id} 
                    value={exaustor.descricao}
                  >
                    {exaustor.descricao}
                  </option>
                ))}
              </select>
              <label htmlFor="temporizacao4">Inicio</label>
              <input
                type="time"
                id="inicioExaustor"
                name="temporizacao3"
                value={inicioExaustor}
                onChange={(e) => setInicioExaustor(e.target.value)}
              />
              <label htmlFor="temporizacao2">Fim</label>
              <input
                type="time"
                id="fimExaustor"
                name="temporizacao4"
                value={fimExaustor}
                onChange={(e) => setFimExaustor(e.target.value)}
              />
            </div>
          </div>
        </div>

        <button id="btnSalvar" onClick={temporizar}>
          Salvar
        </button>
      </div>

      {/* -------------------- Lista de agendados -------------------- */}
      <div id="Lista-agendados">
        <ListaAgendados refreshFlag={refreshFlag} />
      </div>
    </div>
  );
}

export default TelaTemporizacao;